import * as React from "react";
import { Card, Typography, CardContent, Chip, Button, CardActions, CardHeader, Grid, IconButton } from "@material-ui/core";
import { Link } from "react-router-dom";
import { Timeline } from "./timeline.jsx";
const moment = require("moment");
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export class IncubatorCard extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    let { portfolio, type } = this.props;
    let userAvatarCount = portfolio.contributedUsers.filter(cur => cur.hasAvatar).length - 3;
    let description = portfolio.descriptions?portfolio.descriptions[0].text: portfolio.description;
    return (
      <Card style={{ opacity: `${type === 'disabled' ? '0.5' : '1'}` }} >
        <CardContent>
        {type === 'owned' && 
        <IconButton style={{float:'right'}} component="a" href={`/sponsor/editIncubator?id=${portfolio.id}`}>
            <FontAwesomeIcon icon={['far',"edit"]} />
         </IconButton>
         }
        <Link to={this.props.linkTo} className={'incubator-link-card'} >
         {(portfolio.sponsorDisplayName && portfolio.sponsorDisplayName) && <div className='incubator-card-sponsor'>
            <Typography color="textSecondary" style={{ fontSize: '12px' }}>
              BY:
              </Typography>
            <Typography component="p" style={{ marginBottom: '1em' }}>
              {portfolio.sponsorDisplayName.toUpperCase()}
            </Typography>
          </div>}
          <div style={{ height: `200px` }}>
            <Typography variant="h5" component="h2"  color='primary' style={{color:`${(portfolio.titleColor && portfolio.titleColor !== '#000000')?portfolio.titleColor:'primary'}`}} className='incubator-card-name' gutterBottom>
              {portfolio.name && portfolio.name}
            </Typography>
            <Typography color="textSecondary" className='incubator-card-description' component="p">
              {`${description.substring(0,700)}${description.length > 700?"...":''}`}
            </Typography>
          </div>
          <br></br>
          {type !== 'owned' && <div style={{ height: '150px' }}>
            <Timeline type={"center"} portfolio={portfolio}/>
          </div>}
          {type !== 'owned' &&
            <div className='portfolio-right-side'>
              <div className='portfolio-list-card-avatars'>
                {userAvatarCount > 0 && <span className="portfolio-list-card-avatar-text">&nbsp;&nbsp;&nbsp;+{userAvatarCount}</span>}
                {
                  portfolio.contributedUsers.filter(cur => cur.hasAvatar).slice(0, 3).map(cur => {
                    return (
                      <span key={cur.idUser} className="portfolio-list-card-avatar">
                        <img src={window.globals.USER_UPLOADS_BASE_URL + '/' + cur.idUser + '/Avatar.png'} width="20" height="20" />
                      </span>
                    );
                  }
                  )
                }

              </div>
              {portfolio.lastUpdateTime && <Typography color="textSecondary" style={{ fontSize: '12px', textAlign: 'left' }}>
                {`Updated: ${moment(new Date(portfolio.lastUpdateTime)).calendar()}`}
              </Typography>}
            </div>}

          {type !== 'owned' && <div style={{ height: '90px' }}>
            {(type === 'active') &&
              <Chip color={'primary'} label={'Active'}></Chip>
            }
            {(type === 'disabled') &&
              <Chip color={'default'} label={'Closed'}></Chip>
            }
          </div>
          }
          </Link>
        </CardContent>
      </Card>

    );
  }

};